import React, { useEffect, useState } from 'react';
import ComboMultiple from '../../../../../shared/components/Combos/Multiple';
import { createOptions } from './functions';

export const ComboObras = (props:any) =>{
 
  let {options, selectedOptions, isDisabled, onChange} = props;
  let [comboOptions, setComboOptions] = useState(options)

  useEffect(()=>{
    if(options){
      setComboOptions(createOptions(options))
    }
  },[options])

  useEffect(()=>{
    if(comboOptions && comboOptions.length>0)
    {
      let select = !Array.isArray(selectedOptions) ? comboOptions.filter((o:any) => o.value===selectedOptions) : selectedOptions
      onChange && onChange(select)
    }
  },[comboOptions])
 
  return (
    <ComboMultiple {...{...props,...{options:comboOptions}}} id="comboObras"/>
  )
}
export default ComboObras